import { IconsProps } from "./dto";

export function DeparturesIcon(props: IconsProps) {
    return (
        <svg
            id="uuid-1a1f0b90-744c-49fd-b808-24e90ce12172"
            data-name="Livello 2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 382.95 260.59"
            height={props.size}
            width={props.size}
        >
            <g data-name="Livello 1">
                <g>
                    <path
                        fill={props.color}
                        d="M382.95,59.73l-.47,5.89c-5.16,13.92-20.18,19.59-32.84,24.68-73.17,29.41-148.71,53.43-222.06,82.47-23.09,7.31-67.96,12.7-90.27,3.21-12.12-5.15-17.28-16.23-7.01-26.49l.09-1.17L0,103.11l39.29-13.95,54.88,25.78,56.3-21.26L72.76,0l61.48,2.87,98.46,59.61c40.7-11.19,90.14-45.31,132.35-22.85,8.18,4.35,15.97,10.57,17.9,20.09ZM175.82,100.9l-82.15,30.91-53.75-25.36c-3.76-.85-11.18,3.21-15.02,4.56l26.75,40.43c.11,1.1-8.02,6.16-9.49,8.04-.55.7-1.23.47-.12,1.48,17.37,6.2,38.21,4.95,56.28,2.43,10.78-1.5,20.35-4.09,30.61-7.56,75.49-25.52,149.07-57.6,224.34-83.81,2.98-1.31,14.53-7.28,13.91-10.81-.45-2.55-8.43-7.46-10.89-8.63-17.49-8.34-37.31-4.87-54.89,1.22l-70.15,26.09-101.39-61.62-22.88-1.44,68.85,84.07Z"
                    />
                    <rect
                        fill={props.color}
                        x={12.69}
                        y={245.08}
                        width={357.56}
                        height={15.51}
                    />
                </g>
            </g>
        </svg>
    )
}